/**
 * Checks whether a chain structure is compatible with Pioneer editing.
 * A chain is editable in Pioneer only if it has at most 2 links,
 * a single form, a single template, a single prompt,
 * no link types other than form/prompt/template,
 * and does not mix prompt and template links.
 *
 * @param {Object} template - The template object containing the chain and chat.
 * @returns {boolean} true if the chain violates Pioneer editability constraints.
 */
export function isChainIncompatibleWithPioneer(template) {
  const chain = template?.chain;
  const chat = template?.chat;

  if (!chain) return true;
  if (chat) return true; // A chain with a chat template is not compatible
  if (chain.length === 0) return true; // An empty chain is not compatible

  const hasMoreThan2Links = chain.length > 2;
  const hasMultipleForms = chain.filter(c => c.type === 'form').length > 1;
  const hasMultipleTemplates = chain.filter(c => c.type === 'template').length > 1;
  const hasMultiplePrompts = chain.filter(c => c.type === 'prompt').length > 1;
  const hasOtherThanFormsAndPrompts = chain.some(c => c.type !== 'form' && c.type !== 'prompt' && c.type !== 'template');
  const hasBothPromptAndTemplate = chain.some(c => c.type === 'prompt') && chain.some(c => c.type === 'template');
  const formIndex = chain.findIndex(c => c.type === 'form');
  const promptOrTemplateBeforeForm = formIndex !== -1 && chain.slice(0, formIndex).some(c => c.type === 'prompt' || c.type === 'template');

  return (
    hasMoreThan2Links ||
    hasMultipleForms ||
    hasMultipleTemplates ||
    hasMultiplePrompts ||
    hasOtherThanFormsAndPrompts ||
    hasBothPromptAndTemplate ||
    promptOrTemplateBeforeForm
  );
}
